var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"zadarma"}},[_c('div',{attrs:{"id":"zadarmaScripts"}}),(_vm.showClickToCall)?_c('ZadarmaClickToCall'):_vm._e(),(_vm.showCallback)?_c('ZadarmaCallback'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }